module.exports = __webpack_public_path__ + "static/media/tappy-license.e86d3de4.pdf";